export function logToMyService(error: Error, info: React.ErrorInfo) {
    console.log("Reporting error to service...");
    console.log("Error:", error);
    console.log("Component stack:", info.componentStack);
  }